import React,{useContext} from 'react'
import DatePicker from "react-datepicker";

import { AppContext } from "../../AppContext";
import UserSelectBox from "../common/controls/UserSelectBox";

const PoliticalContribJwCole=(props)=> {
    const [appContext, setAppContext] = useContext(AppContext);

    const handleNumberFieldDecimalChange = (e) => {
        if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
            console.log(e.target.value);
          props.handleChange(e);
        }
      };

    return (
        <div className="form-items mt-4">
                        
            <div className="form-columns">

                <div className="form-column">
                    <div className="section-header">Individual Contributing:</div>
                
                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.contributorType ? "" : "warning"}`}>
                            Pre-Approval being submitted for: <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="contributorType" value="Financial Professional" className="form-check-input" checked={props.data.contributorType === "Financial Professional"} onChange={props.handleChange}/>
                                    Financial Professional
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="contributorType" value="Spouse Only" className="form-check-input" checked={props.data.contributorType === "Spouse Only"} onChange={props.handleChange}/>
                                    Spouse Only
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="contributorType" value="Financial Professional and Spouse" className="form-check-input" checked={props.data.contributorType === "Financial Professional and Spouse"} onChange={props.handleChange}/>
                                    Financial Professional and Spouse
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.spouseLastName ? "" : "warning" }`} htmlFor="spouseLastName">Last Name of your Spouse : </label>
                        <input className="form-item-value" type="text" id="spouseLastName" name="spouseLastName" maxLength="500" value={props.data.spouseLastName} onChange={props.handleChange}/>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label`} htmlFor="spouseMiddleName">Middle Name of your Spouse : </label>
                        <input className="form-item-value" type="text" id="spouseMiddleName" name="spouseMiddleName" maxLength="500" value={props.data.spouseMiddleName} onChange={props.handleChange}/>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.spouseFirstName ? "" : "warning" }`} htmlFor="spouseFirstName">First Name of your Spouse : </label>
                        <input className="form-item-value" type="text" id="spouseFirstName" name="spouseFirstName" maxLength="500" value={props.data.spouseFirstName} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.contribTarget ? "" : "warning"}`}>
                        Please indicate the type of activity you are seeking pre-approval for: <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="contribTarget" value="Individual or Campaign" className="form-check-input" checked={props.data.contribTarget === "Individual or Campaign"} onChange={props.handleChange}/>
                                    Contribution to an Individual or a Campaign
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="contribTarget" value="Political Organization" className="form-check-input" checked={props.data.contribTarget === "Political Organization"} onChange={props.handleChange}/>
                                    Contribution to a Political Organization (e.g., Political Party or PAC)
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.politicalOrganizationType ? "" : "warning"}`}>
                        Type of Organization: <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationType" value="Political Party" className="form-check-input" checked={props.data.politicalOrganizationType === "Political Party"} onChange={props.handleChange}/>
                                    Political Party
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationType" value="PAC" className="form-check-input" checked={props.data.politicalOrganizationType === "PAC"} onChange={props.handleChange}/>
                                    PAC
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationType" value="Other" className="form-check-input" checked={props.data.politicalOrganizationType === "Other"} onChange={props.handleChange}/>
                                    Other
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.politicalPartyVoteJurisdiction ? "" : "warning"}`}>
                        If Political Party, are you entitled to vote in this jurisdiction? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="politicalPartyVoteJurisdiction" value="Yes" className="form-check-input" checked={props.data.politicalPartyVoteJurisdiction === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="politicalPartyVoteJurisdiction" value="No" className="form-check-input" checked={props.data.politicalPartyVoteJurisdiction === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.politicalOrganizationName ? "" : "warning" }`} htmlFor="politicalOrganizationName">Name of Organization : </label>
                        <input className="form-item-value" type="text" id="politicalOrganizationName" name="politicalOrganizationName" maxLength="500" value={props.data.politicalOrganizationName} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.politicalOrganizationJurisdiction ? "" : "warning"}`}>
                        Jurisdiction: <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationJurisdiction" value="City" className="form-check-input" checked={props.data.politicalOrganizationJurisdiction === "City"} onChange={props.handleChange}/>
                                    City
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationJurisdiction" value="County" className="form-check-input" checked={props.data.politicalOrganizationJurisdiction === "County"} onChange={props.handleChange}/>
                                    County
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationJurisdiction" value="State" className="form-check-input" checked={props.data.politicalOrganizationJurisdiction === "State"} onChange={props.handleChange}/>
                                    State
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="politicalOrganizationJurisdiction" value="Federal" className="form-check-input" checked={props.data.politicalOrganizationJurisdiction === "Federal"} onChange={props.handleChange}/>
                                    Federal
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contribAmount ? "" : "warning" }`} htmlFor="contribAmount">Contribution Amount :</label>
                        <input className="form-item-value" type="text" id="contribAmount" name="contribAmount" value={props.data.contribAmount} onChange={handleNumberFieldDecimalChange}/>
                    </div>

                    
                    
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isIndividualPriorContrib ? "" : "warning"}`}>
                        Have you made any prior Political Contributions during this election cycle? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isIndividualPriorContrib" value="Yes" className="form-check-input" checked={props.data.isIndividualPriorContrib === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isIndividualPriorContrib" value="No" className="form-check-input" checked={props.data.isIndividualPriorContrib === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.individualPriorContribDetail || props.validation.isIndividualPriorContrib === 'No' ? "" : "warning"}`} htmlFor="individualPriorContribDetail">If yes, please provide details: </label>
                        <textarea rows="3" className="full-width"  id="individualPriorContribDetail" name="individualPriorContribDetail" maxLength="2000" value={props.data.individualPriorContribDetail} onChange={props.handleChange}/>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.individualPriorContribDate || props.validation.isIndividualPriorContrib === 'No' ? "" : "warning"}`} htmlFor="individualPriorContribDate">Date:</label>
                        <div className="form-item-value">
                            <DatePicker selected={props.data.individualPriorContribDate} onChange={p=>props.handleDateChange(p,"individualPriorContribDate")}/>
                        </div>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.individualPriorContribAmount || props.validation.isIndividualPriorContrib === 'No' ? "" : "warning"}`} htmlFor="individualPriorContribAmount">Amount Contributed :</label>
                        <input className="form-item-value" type="text" id="individualPriorContribAmount" name="individualPriorContribAmount" value={props.data.individualPriorContribAmount} onChange={handleNumberFieldDecimalChange}/>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.individualPriorContribCampaignOrganization || props.validation.isIndividualPriorContrib === 'No' ? "" : "warning"}`} htmlFor="individualPriorContribCampaignOrganization">Campaign/Organization: </label>
                        <input className="form-item-value" type="text" id="individualPriorContribCampaignOrganization" name="individualPriorContribCampaignOrganization" value={props.data.individualPriorContribCampaignOrganization} onChange={props.handleChange}/>
                    </div>





                </div>

                <div className="form-column">
                    <div className="section-header">Candidate Information:</div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.candidateName ? "" : "warning" }`} htmlFor="candidateName">Name of the Candidate : </label>
                        <input className="form-item-value" type="text" id="candidateName" name="candidateName" maxLength="500" value={props.data.candidateName} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.officeSought ? "" : "warning" }`} htmlFor="officeSought">Office Sought : </label>
                        <input className="form-item-value" type="text" id="officeSought" name="officeSought" maxLength="500" value={props.data.officeSought} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.electionDate ? "" : "warning"}`} htmlFor="electionDate">Date of Election:</label>
                        <div className="form-item-value">
                            <DatePicker selected={props.data.electionDate} onChange={p=>props.handleDateChange(p,"electionDate")}/>
                        </div>
                    </div>

                    <div className="form-item mt-4">
                        <label className={`form-item-label required ${props.validation.officeSoughtJurisdiction ? "" : "warning" }`}>
                        Jurisdiction of Office sought : <em>(check one)</em>
                        </label>
                        <div className="form-item-value">
                            <div className="label-group-block">
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="City" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "City"} onChange={props.handleChange}/>
                                    City
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="County" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "County"} onChange={props.handleChange}/>
                                    County
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="State" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "State"} onChange={props.handleChange}/>
                                    State
                                </label>
                                <label className="flex-1">
                                    <input type="radio" name="officeSoughtJurisdiction" value="Federal" className="form-check-input" checked={props.data.officeSoughtJurisdiction === "Federal"} onChange={props.handleChange}/>
                                    Federal
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.electionType ? "" : "warning" }`} htmlFor="electionType">Type of Election : </label>
                        <input className="form-item-value" type="text" id="electionType" name="electionType" maxLength="500" value={props.data.electionType} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label`} htmlFor="officeHeld">Office currently held (if any) : </label>
                        <input className="form-item-value" type="text" id="officeHeld" name="officeHeld" maxLength="500" value={props.data.officeHeld} onChange={props.handleChange}/>
                    </div>




                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isCandidateAssociated ? "" : "warning"}`}>
                        Are you, in any way, associated with the Candidate, Government Agency, OR Municipality? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isCandidateAssociated" value="Yes" className="form-check-input" checked={props.data.isCandidateAssociated === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isCandidateAssociated" value="No" className="form-check-input" checked={props.data.isCandidateAssociated === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label ${props.validation.candidateAssociatedDesc || props.validation.isCandidateAssociated === 'No' ? "" : "warning"}`} htmlFor="candidateAssociatedDesc">If Yes, please explain : </label>
                        <input className="form-item-value" type="text" id="candidateAssociatedDesc" name="candidateAssociatedDesc" maxLength="500" value={props.data.candidateAssociatedDesc} onChange={props.handleChange}/>
                    </div>
                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.isCandidateClient ? "" : "warning"}`}>
                        Is the Candidate a client of yours or JW Cole? :
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="isCandidateClient" value="Yes" className="form-check-input" checked={props.data.isCandidateClient === "Yes"} onChange={props.handleChange}/>
                                Yes
                            </label>
                            <label>
                                <input type="radio" name="isCandidateClient" value="No" className="form-check-input" checked={props.data.isCandidateClient === "No"} onChange={props.handleChange}/>
                                No
                            </label>
                        </div>
                    </div>





                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contribPaymentType ? "" : "warning"}`}>
                        Type of Contribution: <em>(check one)</em>
                        </label>
                        <div className="form-item-value label-group">
                            <label>
                                <input type="radio" name="contribPaymentType" value="Money" className="form-check-input" checked={props.data.contribPaymentType === "Money"} onChange={props.handleChange}/>
                                Money
                            </label>
                            <label>
                                <input type="radio" name="contribPaymentType" value="In-Kind" className="form-check-input" checked={props.data.contribPaymentType === "In-Kind"} onChange={props.handleChange}/>
                                In-Kind
                            </label>
                        </div>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.candidateContribAmount ? "" : "warning" }`} htmlFor="candidateContribAmount">Amount of Contribution :</label>
                        <input className="form-item-value" type="text" id="candidateContribAmount" name="candidateContribAmount" value={props.data.candidateContribAmount} onChange={handleNumberFieldDecimalChange}/>
                    </div>
                    
                    <div className="form-item">
                        <label className={`form-item-label`} htmlFor="otherPaymentMethod">
                        If the above amount will be paid in other form than cash or check, please indicate the form that will be used :
                        </label>
                        <textarea rows="3" className="full-width"  id="otherPaymentMethod" name="otherPaymentMethod" maxLength="2000" value={props.data.otherPaymentMethod} onChange={props.handleChange}/>
                    </div>

                    <div className="form-item">
                        <label className={`form-item-label`} htmlFor="otherContribMethod">
                        If in-kind, please explain :
                        </label>
                        <textarea rows="3" className="full-width"  id="otherContribMethod" name="otherContribMethod" maxLength="2000" value={props.data.otherContribMethod} onChange={props.handleChange}/>
                    </div>


                    <div className="form-item">
                        <label className={`form-item-label required ${props.validation.contribDate ? "" : "warning"}`} htmlFor="contribDate">Contribution or Planned For Date:</label>
                        <div className="form-item-value">
                            <DatePicker selected={props.data.contribDate} onChange={p=>props.handleDateChange(p,"contribDate")}/>
                        </div>
                    </div>


                    <div className="form-item">
                        <label className="form-item-label" htmlFor="attachment">Attachment Document (if applicable) :</label>
                        <div className="form-item-value placeholder">
                            <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                        </div>
                    </div>
                    <div className="form-item">
                        {appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                            <UserSelectBox label='Submit On Behalf of (Optional) : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={() => { return props.data.submittedFor ? { value: props.data.submittedFor, label: props.data.submittedForLabel } : null }} />
                        }
                    </div>
                </div>

            </div>

        </div>
    )
}

export default PoliticalContribJwCole
